import type { UnknownQueryParam, PageRouteDefinition, QueryParamValues, QueryParamValuesSetter } from "@octopusdeploy/portal-routes";
import type { ReactElement } from "react";
import type { Loader } from "~/routing/pageRegistrations/Loader";
import type { LoadingContentRender, PageRegistration } from "~/routing/pageRegistrations/PageRegistration";
import type { StandardLoaderContext } from "~/routing/pageRegistrations/StandardLoaderContext";
import type { StandardPageContext } from "~/routing/pageRegistrations/StandardPageContext";
import type { PageIdentity } from "./PageIdentity";
export function createLevel1TenantPageRegistration<RouteParams, QueryParams extends UnknownQueryParam[], LoaderData>(route: PageRouteDefinition<RouteParams, QueryParams>, config: {
    render: (parameters: {
        context: StandardPageContext;
        loaderData: LoaderData;
        routeParams: RouteParams;
        queryParams: QueryParamValues<QueryParams>;
        setQueryParams: QueryParamValuesSetter<QueryParamValues<QueryParams>>;
    }) => ReactElement;
    pageIdentity: PageIdentity;
    loader?: Loader<LoaderData, StandardLoaderContext, RouteParams, QueryParams>;
    loadingTitle?: string;
    loadingContent?: LoadingContentRender;
    isFullWidth?: boolean;
}): PageRegistration<RouteParams, QueryParams, LoaderData, StandardLoaderContext, StandardPageContext> {
    return {
        route,
        render: config.render,
        pageIdentity: config.pageIdentity,
        verticalNavigationPageArea: "Projects",
        searchKeywords: [],
        loader: config.loader,
        loadingTitle: config.loadingTitle,
        loadingContent: config.loadingContent,
        level: 1,
        isFullWidth: config.isFullWidth,
    };
}
export function createLevel2TenantPageRegistration<RouteParams, QueryParams extends UnknownQueryParam[], LoaderData>(route: PageRouteDefinition<RouteParams, QueryParams>, config: {
    render: (parameters: {
        context: StandardPageContext;
        loaderData: LoaderData;
        routeParams: RouteParams;
        queryParams: QueryParamValues<QueryParams>;
        setQueryParams: QueryParamValuesSetter<QueryParamValues<QueryParams>>;
    }) => ReactElement;
    pageIdentity: PageIdentity;
    loader?: Loader<LoaderData, StandardLoaderContext, RouteParams, QueryParams>;
    loadingTitle?: string;
    loadingContent?: LoadingContentRender;
    isFullWidth?: boolean;
}): PageRegistration<RouteParams, QueryParams, LoaderData, StandardLoaderContext, StandardPageContext> {
    return {
        route,
        render: config.render,
        pageIdentity: config.pageIdentity,
        verticalNavigationPageArea: "Projects",
        searchKeywords: [],
        loader: config.loader,
        loadingTitle: config.loadingTitle,
        loadingContent: config.loadingContent,
        level: 2,
        isFullWidth: config.isFullWidth,
    };
}
